import React, { FC } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom'
import BillingOverAll from './components/BillingOverAll';
import EditCreditCard from './components/EditCreditCard';
import CreditCardDetails from './components/CreditCardDetails';

const AccountContent: FC = () => {
  return (
    <Switch>
      <Route
        path="/account/billing/edit-credit-card/:groupId"
        render={() => <EditCreditCard />}
      />
      <Route
        path="/account/billing/credit-card-details/:groupId"
        render={() => <CreditCardDetails />}
      />
      <Route
        exact
        path="/account/billing/"
        render={() => <BillingOverAll />}
      />

      <Redirect to="/account/billing/" />
    </Switch>
  );
};

export default AccountContent;

